import { useRouter } from "next/router";
import CustomToast from "components/atoms/CustomToast";
import { useDetailAlarmClick } from "./DetailHeaderBtnsClick";
import { useStockAlarm } from "lib/analytics/react/hooks";
import { useContext, useEffect } from "react";
import { DetailButtonsContext } from "./Index";

function AlarmButton({}: {}) {
  const router = useRouter();
  const { detailData } = useContext(DetailButtonsContext);

  const stockAlarm = useStockAlarm();
  const {
    handleAlarmClick,
    alarmToastVisible,
    alarmSuccessToastVisible,
    isAlarmRegistered,
    setAlarmSuccessToastVisible,
  } = useDetailAlarmClick();

  useEffect(() => {
    if (alarmSuccessToastVisible) {
      stockAlarm.success();
    }
  }, [alarmSuccessToastVisible]);

  return (
    <div
      className="p-[6px] cursor-pointer relative"
      onClick={async () => {
        window.dataLayer.push({
          event: "cDetailAlarm",
        });
        stockAlarm.start({
          ticker: detailData?.ITEM_CD_DL,
          market: detailData?.LOC === "kr" ? "kr" : "us",
          from_section_id: "stock_header",
        });
        await handleAlarmClick(stockAlarm.success, stockAlarm.fail);
      }}
    >
      {isAlarmRegistered ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.4004 13.8121C18.4004 14.0331 18.4579 14.2502 18.5672 14.4423C18.7937 14.8402 19.2644 15.0397 19.6161 15.3329C19.8507 15.5285 20 15.823 20 16.1523C20 16.7412 19.5226 17.2187 18.9336 17.2187H5.07055C4.77508 17.2187 4.50767 17.0985 4.31454 16.9044C4.12027 16.7112 4 16.4437 4 16.1481C4 15.8188 4.14959 15.5257 4.38445 15.3312C4.73673 15.0395 5.2067 14.8413 5.43429 14.4446C5.54533 14.2511 5.60375 14.0318 5.60375 13.8087V10.3663C5.60375 8.88616 6.04808 7.571 6.93674 6.42081C7.82539 5.27061 9.22947 4.37442 10.4025 4.16053C11.5755 3.94664 12.4286 3.94634 13.6017 4.16053C14.7747 4.37472 16.1788 5.27061 17.0674 6.42081C17.9561 7.571 18.4004 8.88616 18.4004 10.3663V13.8121Z"
            fill="#FFC633"
          />
          <path
            d="M12 20.5102C13.3807 20.5102 14.5 19.3909 14.5 18.0102H9.5C9.5 19.3909 10.6193 20.5102 12 20.5102Z"
            fill="#F3A50E"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.5573 13.8557C18.5573 14.0822 18.6162 14.3048 18.7283 14.5016C18.9604 14.9095 19.4429 15.1139 19.8034 15.4145C20.0438 15.615 20.1969 15.9168 20.1969 16.2544C20.1969 16.8581 19.7075 17.3474 19.1038 17.3474H4.89419C4.59133 17.3474 4.31724 17.2243 4.11927 17.0253C3.92015 16.8273 3.79688 16.5531 3.79688 16.2501C3.79688 15.9126 3.95021 15.6121 4.19094 15.4128C4.55202 15.1138 5.03374 14.9107 5.26702 14.504C5.38083 14.3056 5.44072 14.0809 5.44072 13.8522V9.94828C5.44072 8.43118 5.89615 7.08315 6.80703 5.90419C7.7179 4.72524 9.15708 3.80665 10.3594 3.58741C11.5618 3.36817 12.4362 3.36787 13.6386 3.58741C14.8409 3.80695 16.2801 4.72524 17.191 5.90419C18.1019 7.08315 18.5573 8.43118 18.5573 9.94828V13.8557Z"
            fill="var(--gray30)"
          />
          <path
            d="M11.9969 20.7213C13.4121 20.7213 14.5594 19.574 14.5594 18.1588H9.43437C9.43437 19.574 10.5816 20.7213 11.9969 20.7213Z"
            fill="var(--gray30)"
          />
        </svg>
      )}
      <CustomToast
        message={
          router.locale == "ko" && isAlarmRegistered
            ? "이제부터 문자로 알림을 받아요"
            : isAlarmRegistered &&
              router.locale !== "ko" &&
              "Successfully Alarm Registered"
        }
        isVisible={alarmSuccessToastVisible && isAlarmRegistered}
        onClose={() => setAlarmSuccessToastVisible(false)}
        width={router.locale === "ko" ? 255 : 275}
        successIconFill={"#34BB7A"}
        customAnimation="bottom-toast-detail-alarm-register"
        duration={2000}
      />
      {/* <AlarmFloatingButton
        isVisible={(type === "ai" || !type) && !isAlarmRegistered}
        onClick={async () => {
          await handleAlarmClick();
        }}
      /> */}
    </div>
  );
}

export default AlarmButton;
